export const FeatureFlagsActionTypes = {
  NEW_LIKES_LOGIC: '@newfeature/NEW_LIKES_LOGIC'
};
